import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-body" }
const _hoisted_2 = { class: "modal--title" }
const _hoisted_3 = { class: "dropdown-row" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "active-lawyer-data"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "row-value" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "row-value" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "row-value" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "row-value" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "row-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    "is-open": $setup.props.isOpen,
    onClose: $setup.onClose
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, "Connect Trust account to " + _toDisplayString($setup.props.estateName), 1),
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "dropdown-row-label" }, "Choose a Trust account:", -1)),
          _createVNode($setup["Dropdown"], { class: "dropdown" }, {
            control: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["dropdown-button", [{ 'active-label': $setup.activeLawyer.firstName }]])
              }, _toDisplayString($setup.activeLawyer?.detailsId?.companyName), 3)
            ]),
            dropdown: _withCtx(() => [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lawyers, (lawyer) => {
                  return (_openBlock(), _createElementBlock("li", {
                    onClick: ($event: any) => ($setup.onLawyer(lawyer)),
                    class: _normalizeClass({ 'dropdown__item-active': $setup.activeLawyer.firstName === lawyer.firstName })
                  }, _toDisplayString(lawyer.detailsId.companyName), 11, _hoisted_4))
                }), 256))
              ])
            ]),
            _: 1
          })
        ]),
        ($setup.activeLawyer.detailsId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row-title" }, "Name:", -1)),
                _createElementVNode("div", _hoisted_7, _toDisplayString($setup.activeLawyer.firstName) + " " + _toDisplayString($setup.activeLawyer.lastName), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row-title" }, "Email:", -1)),
                _createElementVNode("div", _hoisted_9, _toDisplayString($setup.activeLawyer.email), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row-title" }, "Phone:", -1)),
                _createElementVNode("div", _hoisted_11, _toDisplayString($setup.activeLawyer.phone), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row-title" }, "Company:", -1)),
                _createElementVNode("div", _hoisted_13, _toDisplayString($setup.activeLawyer.detailsId.companyName), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row-title" }, "Address:", -1)),
                _createElementVNode("div", _hoisted_15, _toDisplayString($setup.activeLawyer.detailsId.companyAddress), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", { class: "controls" }, [
          _createElementVNode("button", {
            class: "button default",
            onClick: $setup.onClose
          }, "Cancel"),
          _createElementVNode("button", {
            class: "button default primary save",
            onClick: $setup.onAssign
          }, "Assign")
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-open"]))
}